// extracted by mini-css-extract-plugin
export default {"spacing":"InviteUserSkeleton_spacing__bwFCQ"};